var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAws(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "aws") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.4,20.6a5.1,5.1,0,0,0,.2,1.3l.4,1a.4.4,0,0,1,.1.3c0,.2-.1.3-.2.5l-1,.6h-.3a.6.6,0,0,1-.5-.2,1.8,1.8,0,0,1-.5-.7,5.6,5.6,0,0,1-.5-.8,5.4,5.4,0,0,1-4.3,2,4,4,0,0,1-2.9-1.1,3.8,3.8,0,0,1-1.1-2.8,3.9,3.9,0,0,1,1.4-3,5.2,5.2,0,0,1,3.5-1.1h1.6l1.7.3V16a3.5,3.5,0,0,0-.7-2.3A3.8,3.8,0,0,0,8.9,13l-1.6.2-1.6.5-.5.2H5c-.2,0-.3-.2-.3-.5v-.7a.7.7,0,0,1,.1-.5l.4-.3A7.5,7.5,0,0,1,7,11.3,9.1,9.1,0,0,1,9.3,11a5.5,5.5,0,0,1,3.9,1.2,4.9,4.9,0,0,1,1.2,3.6v4.8ZM8.5,22.8l1.5-.3a4.2,4.2,0,0,0,1.4-.9,3.1,3.1,0,0,0,.5-1c0-.3.1-.7.1-1.2v-.6l-1.3-.3H9.3a3.4,3.4,0,0,0-2.2.6,2.1,2.1,0,0,0-.7,1.7,2.1,2.1,0,0,0,.5,1.5A2.1,2.1,0,0,0,8.5,22.8Zm11.7,1.6a.6.6,0,0,1-.5-.2.9.9,0,0,1-.4-.6L15.9,12.3a1.8,1.8,0,0,1-.1-.6.3.3,0,0,1,.3-.3h2a1.6,1.6,0,0,1,.3.6l2.5,9.7,2.3-9.7a.8.8,0,0,1,.2-.6h2.4l.3.6,2.3,9.8,2.5-9.8.3-.6h1.9c.3,0,.4.1.4.3V12c0,.1-.1.2-.1.3L29.8,23.7a.6.6,0,0,1-.3.5l-.5.2H27.7a.7.7,0,0,1-.8-.8l-2.3-9.4-2.3,9.4a.8.8,0,0,1-.2.6l-.6.2Zm18.8.4a8.3,8.3,0,0,1-2.2-.3l-1.7-.6a1.1,1.1,0,0,1-.5-.4c0-.1-.1-.3-.1-.4v-.8a.4.4,0,0,1,.4-.4h.2l.4.2,1.6.5,1.8.2a4.1,4.1,0,0,0,2.1-.5,1.6,1.6,0,0,0,.8-1.4,1.5,1.5,0,0,0-.4-1,3.5,3.5,0,0,0-1.5-.8l-2.1-.7A4.6,4.6,0,0,1,35.4,17a3.6,3.6,0,0,1-.7-2.2,2.9,2.9,0,0,1,.4-1.6,2.9,2.9,0,0,1,1-1.2l1.6-.8,1.8-.2h1.9l.9.3.6.2c.2.1.3.3.4.4a.7.7,0,0,1,.1.5v.7c0,.3-.1.4-.3.4a.6.6,0,0,1-.5-.2,8.8,8.8,0,0,0-2.9-.5,3.6,3.6,0,0,0-1.9.4,1.4,1.4,0,0,0-.7,1.3,1.4,1.4,0,0,0,.5,1,2.9,2.9,0,0,0,1.6.8l2,.7a4,4,0,0,1,2.3,1.4,3.1,3.1,0,0,1,.7,2,4.3,4.3,0,0,1-.4,1.7,3.5,3.5,0,0,1-1.1,1.3,3,3,0,0,1-1.6.8A4.9,4.9,0,0,1,39,24.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8,31.9C37,35.4,30,37.3,24,37.3A32.1,32.1,0,0,1,2.2,29c-.5-.4,0-1,.5-.6a44,44,0,0,0,21.8,5.8,45.2,45.2,0,0,0,16.6-3.4C41.9,30.4,42.6,31.3,41.8,31.9Zm2-2.3c-.6-.8-4.1-.4-5.6-.2s-.6-.4-.2-.7c2.8-1.9,7.3-1.3,7.8-.7s-.1,5.2-2.7,7.4c-.4.3-.8.1-.6-.3S44.4,30.4,43.8,29.6Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAws);
export default __webpack_public_path__ + "static/media/aws.3e0903b2bef046a2bba71707778cefc1.svg";
export { ForwardRef as ReactComponent };